import { DebtNumberError } from "../types/errors/DebtNumberError";

export abstract class ApiService {
    async handleResponse(response: Response) {
        if (response.ok) {
            return response;
        } else if (response.status === 401) {
            await fetch("/services/login/api/token/logout", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            window.location.assign("/");
            return Promise.reject("Unauthorized request");
        } else {
            throw new DebtNumberError(response.status.toString());
        }
    }

    async handleResponseWithoutRedirect(response: Response) {
        if (response.ok) {
            return response;
        } else if (response.status === 401) {
            await fetch("/services/login/api/token/logout", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            console.log("Status " + response);
            // window.location.assign("/");
            return response.status.toString();
        } else {
            throw new Error(response.status.toString());
        }
    }
}
